module.exports = __webpack_public_path__ + "media/my_images/detail/treat-17da651436b086578d46a1a2df0c681d.svg";